import React from 'react';
import { Box } from '@mui/material';
import { CareSourceStatusPanel, CARE_SOURCE_CONTEXTS } from '../../../features/careSourceProcessing';

const MobileTodayCapturePanel = ({
  child,
  onReviewTimeline,
  initialOpenCaptureDetailsKey = '',
  initialOpenCaptureRequestKey = '',
  onReviewAppointment,
  canManageAppointments,
  appointmentTimeZone,
}) => (
  <Box sx={{ mb: 0 }}>
    <CareSourceStatusPanel
      childId={child?.id || ''}
      sourceContext={CARE_SOURCE_CONTEXTS.TIMELINE}
      onReviewTimeline={onReviewTimeline}
      initialOpenCaptureDetailsKey={initialOpenCaptureDetailsKey}
      initialOpenCaptureRequestKey={initialOpenCaptureRequestKey}
      onReviewAppointment={onReviewAppointment}
      canManageAppointments={canManageAppointments}
      appointmentTimeZone={appointmentTimeZone}
    />
  </Box>
);

export default MobileTodayCapturePanel;
